import { CustomerSensitiveData } from '../../services/auth';

export interface SensitiveStateInterface {
  customerSensitiveData: CustomerSensitiveData;
}

export default class SensitiveState implements SensitiveStateInterface {
  // eslint-disable-next-line no-useless-constructor
  constructor(public customerSensitiveData: CustomerSensitiveData = {}) {}
}
